"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var immutable_1 = require("immutable");
var sub_form_settings_model_1 = require("../components/designer/form/panel/sub-form-settings.model");
var workflow_form_settings_model_1 = require("../components/designer/form/panel/workflow-form-settings.model");
var layout_utils_1 = require("../utils/layout-utils");
var designer_layout_row_model_1 = require("./designer-layout-row.model");
var form_card_model_1 = require("./form-models/form-card.model");
var DesignerContentLayoutModel = /** @class */ (function () {
    function DesignerContentLayoutModel(tabs) {
        this.layoutRows = [];
        this.tabs = tabs || [];
    }
    DesignerContentLayoutModel.prototype.addRowOfCards = function (cardRow) {
        this.layoutRows.push(cardRow);
    };
    DesignerContentLayoutModel.prototype.insertRowOnIndex = function (cardRow, indexToPush) {
        this.layoutRows.splice(indexToPush, 0, cardRow);
    };
    DesignerContentLayoutModel.prototype.insertInLowerRow = function (rowId) {
        var rowToDropInIndex;
        for (var i = 0; i < this.layoutRows.length; i++) {
            if (this.layoutRows[i].id === rowId) {
                rowToDropInIndex = i + 1;
                break;
            }
        }
        var newRow = new designer_layout_row_model_1.DesignerLayoutRowModel();
        newRow.id = layout_utils_1.LayoutUtils.uniqueId();
        if (rowToDropInIndex === this.layoutRows.length) {
            this.layoutRows.push(newRow);
        }
        else {
            this.layoutRows.splice(rowToDropInIndex, 0, newRow);
        }
        return newRow;
    };
    DesignerContentLayoutModel.prototype.insertInUpperRow = function () {
        var newRow = new designer_layout_row_model_1.DesignerLayoutRowModel();
        newRow.id = layout_utils_1.LayoutUtils.uniqueId();
        this.layoutRows.splice(0, 0, newRow);
        return newRow;
    };
    DesignerContentLayoutModel.prototype.isWithTabs = function () {
        return this.tabs.length !== 0;
    };
    DesignerContentLayoutModel.prototype.isEmpty = function () {
        return this.layoutRows.length === 0 && this.tabs.length === 0;
    };
    DesignerContentLayoutModel.prototype.makeEmptyContent = function () {
        var formCardModel = new form_card_model_1.FormCardModel();
        formCardModel.id = layout_utils_1.LayoutUtils.uniqueId();
        var designerLayoutRowModel = new designer_layout_row_model_1.DesignerLayoutRowModel([
            formCardModel,
        ]);
        designerLayoutRowModel.id = layout_utils_1.LayoutUtils.uniqueId();
        this.layoutRows.push(designerLayoutRowModel);
    };
    DesignerContentLayoutModel.prototype.getContentProperties = function () {
        var _this = this;
        return immutable_1.Map().withMutations(function (mutator) {
            if (skynet_store_utilities_1.notNil(_this.subFormSettings)) {
                mutator.set('popup_properties', sub_form_settings_model_1.SubFormSettingsModel.toJson(_this.subFormSettings));
            }
            if (skynet_store_utilities_1.notNil(_this.workflowFormSettings)) {
                mutator.set('workflow_popup_properties', workflow_form_settings_model_1.serializeWorkflowFormSettingsModel(_this.workflowFormSettings));
            }
        });
    };
    return DesignerContentLayoutModel;
}());
exports.DesignerContentLayoutModel = DesignerContentLayoutModel;
//# sourceMappingURL=designer-content-layout.model.js.map